export const ExperimentsConsts = {
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  FormEditorKBContent: 'specs.bookings.FormEditorKBContent',
  MultiLocationUoU: 'specs.bookings.MultiLocationUoU',
  AddonsUOU: 'specs.bookings.AddonsUOU',
  AddonsWithPlanOnlyUOU: 'specs.bookings.AddonsAndPlanOnlyUOU',
  SingleLineItemPreviewPrice: 'specs.bookings.SingleLineItemPreviewPrice',
  calendarNewSummary: 'specs.bookings.calendar-summary',
};
